import { useState } from "react";
import { Check, Copy } from "lucide-react";

import { Button } from "components/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "components/ui/tooltip";

export function CopyButton({
  targetId = "",
  size = "icon",
  variant = "outline",
  className = "",
  tooltipMessage = "Copy",
}) {
  const [isCopied, setIsCopied] = useState(false);

  const copyToClipboard = () => {
    const elem = document.getElementById(targetId);

    if (elem?.textContent) {
      navigator.clipboard.writeText(elem.textContent);
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 1000);
    }
  };

  return (
    <Tooltip>
      <TooltipTrigger
        render={
          <Button
            variant={variant}
            size={size}
            className={className}
            onClick={copyToClipboard}
          >
            {isCopied ? <Check /> : <Copy />}
          </Button>
        }
      />
      <TooltipContent>{tooltipMessage}</TooltipContent>
    </Tooltip>
  );
}
